import { Box, Button, Grid, Typography } from "@mui/material";

import StyledButton from "components/Styled/Button";

interface Props {
  stepNumber: number;
  title: JSX.Element | string;
  description: JSX.Element | string;
  body: JSX.Element;
  buttonNext?: JSX.Element | string;
  buttonBack?: JSX.Element | string;
  onNext?: () => void;
  onBack?: () => void;
  loading?: boolean;
  annotation?: string;
  isInsideForm?: boolean;
}

const StyledVaPage = ({
  stepNumber,
  title,
  description,
  body,
  buttonBack,
  buttonNext,
  onBack,
  onNext,
  loading,
  annotation,
  isInsideForm = false,
}: Props) => {
  const renderPage = () => {
    return (
      <>
        <Grid container justifyContent="center">
          <Box
            sx={{
              borderRadius: 20,
              fontWeight: 500,
              border: "1px black solid",
              px: 2,
              py: 1,
            }}
          >
            Step {stepNumber}/6 {annotation}
          </Box>
        </Grid>
        <Typography
          textAlign="center"
          variant="h2"
          sx={{
            fontSize: { xs: 25, md: 40 },
            fontWeight: 400,
            mb: 2,
          }}
        >
          {title}
        </Typography>

        <Typography textAlign="center" sx={{ mb: 4, fontSize: 18 }}>
          {description}
        </Typography>

        {body}

        {buttonNext && onNext && (
          <Grid container justifyContent="center" sx={{ mt: 2 }}>
            <StyledButton
              disableElevation
              variant="contained"
              styles={{ px: 3, fontSize: 16 }}
              type="submit"
              loading={loading}
              onClick={onNext}
            >
              {buttonNext}
            </StyledButton>
          </Grid>
        )}
        {buttonBack && onBack && (
          <Grid container justifyContent="center" sx={{ mt: 2 }}>
            <Button sx={{ fontSize: 14, color: "black" }} onClick={onBack}>
              <Box
                sx={{ mr: 1 }}
                component="i"
                className="fa-regular fa-circle-arrow-left"
              />
              {buttonBack}
            </Button>
          </Grid>
        )}
      </>
    );
  };
  return isInsideForm ? (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (onNext) {
          onNext();
        }
      }}
    >
      {renderPage()}
    </form>
  ) : (
    renderPage()
  );
};

export default StyledVaPage;
